import styled from "styled-components";

export const Container = styled.aside`
    background: #32465B;
    color: #EEEAE0;
    height: 100%;
    width: 66px;
    position: fixed;
    z-index: 2;
    top: 0;
    text-align: center;
    float: left;

    .bottom{
        position: absolute;
        bottom: 0;
        padding: 15px;

        a{ color: #fff}
        a:hover{ color: var(--verde)}

        span{ font-size: 35px}
    }

    @media(max-width: 493px) {
        width: 46px;

        .bottom{
        padding: 5px;
        }
    }
    
    @media(max-width: 450px) {
        height: 205px;
        border-radius: 0 0 15px 0;
        .bottom{
            z-index: 5;
        }
    }

    @media(max-width: 280px) {
        width: 33px;
        height: 190px;
        .icoChat{
          display: none;
        }
    }

    
`;

export const Marca = styled.div`
    display: block;
    padding: 11px 0 7px 0;
    border-bottom: dotted 1px rgba(255,255,255,0.2);

    img{ width: 70%; height: auto }


`
export const Buttons = styled.div`
    border: var(--verde) solid 2px;
    background: var(--verde);
    color: #fff;
    border-radius: 23px;
    display: inline-block;
    margin: 13px auto;

    button:first-child{
        border-radius: 21px 21px 0 0;
    }
    button:last-child{
        border-radius: 0 0 21px 21px;
    }
    button{
        display: block;
        background: #53C3BA;
        color: #32465B;
        padding: 0px;        
        margin: 3px;
        cursor: pointer;        
        font-weight: 100;        
        border:none;

        span{
            font-size: 2.3rem;
            line-height: 2.7rem;
            width: 2rem;            
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 900;
            transition: all 0.3s;
        }
        
        &:hover{
            background: var(--darkblue);
            color: var(--verde)
        }
    }
    @media(max-width: 493px) {
        button{
            span{
                font-size: 2rem;
                line-height: 2.4rem;
                width: 1.7rem;          
            }
        }
    }
    @media(max-width: 280px) {
        button{
          margin: 1px;
          span{
              font-size: 1.5rem;
              line-height: 2.4rem;
              width: 1rem;          
          }
        }
    }

`
